import React from 'react';
import PropTypes from 'prop-types';
import { Box, Container, Divider, Typography } from '@mui/material';
import { useStyles } from './styles';
import CustomButton from 'components/CustomButton';
import NextLink from 'next/link';
import ReactGA from 'react-ga4';
import { useRouter } from 'next/router';
import getCleverTap from 'utils/clevertap';

const Props = {
  marginLeftPercentage: PropTypes.number.isRequired,
  textTitle: PropTypes.node.isRequired,
  textDescription: PropTypes.node.isRequired,
};

export default function HeaderInformation({ marginLeftPercentage, textTitle, textDescription }) {
  const classes = useStyles();
  const router = useRouter();
  const clevertap = getCleverTap();

  function handleBookDemoClick() {
    ReactGA.event({
      category: 'landing_page',
      action: 'book_demo_request_click',
      label: "When the user clicks to 'Book a Demo' button on the landing page",
    });

    clevertap.event.push('Payment check-out page viewed', {
      Product: 'MTG',
      URL: router.asPath,
      Description: 'Book a Demo Click',
    });
  }

  return (
    <Container>
      <Box
        className={classes.mainInformationHeader}
        style={{ marginLeft: `${marginLeftPercentage}%` }}
        height={0}
      />

      <Box display="flex" alignItems="center" justifyContent="center" height={160}>
        <Typography className={classes.colorWhite} variant="h4" component="h1">
          <b>{textTitle}</b>
        </Typography>

        <Divider className={classes.verticalDivider} />

        <Typography className={classes.colorWhite} variant="h6" component="h2">
          {textDescription}
        </Typography>

        <Box display="flex" flexDirection="column" pl={6}>
          <Box mb={4}>
            <NextLink href="/institutions/book-a-demo" passHref={true}>
              <CustomButton onClick={handleBookDemoClick} variant="buttonWhiteTextPurple">
                Book a Demo
              </CustomButton>
            </NextLink>
          </Box>

          <CustomButton
            variant="transparentButtonBorderWhite"
            onClick={() => window.open('/usaco')}
          >
            View Use Cases
          </CustomButton>
        </Box>
      </Box>
    </Container>
  );
}

HeaderInformation.propTypes = Props;
